(() => {
  const popup = document.querySelector('[data-karantis-pdp-popup]');
  if (!popup || typeof popup.showModal !== 'function') return;
  const storageKey = 'karantis-pdp-welcome-dismissed';
  const closePopup = () => {
    if (popup.open) popup.close();
    try { window.sessionStorage.setItem(storageKey, '1'); } catch (error) { /* Storage may be unavailable. */ }
  };
  popup.querySelector('[data-karantis-popup-close]')?.addEventListener('click', closePopup);
  popup.addEventListener('cancel', () => {
    try { window.sessionStorage.setItem(storageKey, '1'); } catch (error) { /* Storage may be unavailable. */ }
  });
  popup.addEventListener('close', () => {
    try { window.sessionStorage.setItem(storageKey, '1'); } catch (error) { /* Storage may be unavailable. */ }
  });
  popup.addEventListener('click', (event) => {
    const bounds = popup.getBoundingClientRect();
    const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    if (outside) closePopup();
  });
  let dismissed = false;
  try { dismissed = window.sessionStorage.getItem(storageKey) === '1'; } catch (error) { /* Storage may be unavailable. */ }
  const success = Boolean(popup.querySelector('.karantis-pdp-welcome__success'));
  if (!dismissed || success) {
    window.setTimeout(() => {
      if (!popup.open && document.visibilityState === 'visible') popup.showModal();
    }, success ? 250 : Number(popup.dataset.delay || 8000));
  }
})();
